import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import type { FilterOption } from '../../-types';

export function FilterItem({ id, name, count, checked, onCheckedChange }: FilterOption) {
  return (
    <div className="mb-1 flex items-center py-1 px-1 rounded-lg transition-all duration-200 border border-transparent hover:border-blue-200 dark:hover:border-blue-700/60 hover:shadow-lg hover:shadow-blue-500/10 dark:hover:shadow-blue-400/20 hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 dark:hover:from-blue-950/30 dark:hover:to-indigo-950/30">
      <Checkbox
        checked={checked}
        onCheckedChange={onCheckedChange}
        id={String(id)}
        className="ml-3 h-4 w-4 border-2 border-slate-300 dark:border-gray-500 data-[state=checked]:border-blue-500 data-[state=checked]:bg-blue-500 transition-all duration-200 hover:border-blue-400 dark:hover:border-blue-400 hover:shadow-sm"
      />
      <Label
        htmlFor={String(id)}
        className="flex w-full items-center justify-between gap-3 cursor-pointer transition-colors duration-200"
      >
        <span className="text-sm font-medium text-slate-700 dark:text-gray-300 transition-colors duration-200">
          {name}
        </span>
        <span className="px-2 py-1 text-xs font-semibold bg-gradient-to-r from-slate-100 to-slate-200 dark:from-gray-700/60 dark:to-gray-600/60 text-slate-600 dark:text-gray-300 rounded-full transition-all duration-200">
          {count}
        </span>
      </Label>
    </div>
  );
}
